export default "__VITE_ASSET__6huxyyfA__"